import { path } from 'ramda';
import { IOfferState } from '../../redux/reducers';

/**
 *
 * @description Возвращает id ЖК
 */
export function getJKId(offer: IOfferState): number | undefined {
  return path<number>(['geo', 'jk', 'id'], offer);
}
